import React, { Component, createRef } from 'react';
import {
    Box,
    Typography,
    Checkbox,
    FormControlLabel,
    TextField,
    Paper,
    Grid,
    Button
} from '@mui/material';

class InspectorCelular extends Component {
    constructor(props) {
        super(props);
        this.state = {
            frenteOk: true,
            versoOk: true,
            lateralEsquerdaOk: true,
            lateralDireitaOk: true,
            topoOk: true,
            baseOk: true,
            senhaTexto: '',
            senhaPadrao: []
        };

        this.canvasRef = createRef();
        this.isDrawing = false;
        this.points = [];
    }

    componentDidMount() {
        this.initCanvas();
        // Notifica o estado inicial ao pai, se necessário
        this.notificarMudanca();
    }

    // Função auxiliar para estruturar os dados e enviar para o componente pai
    notificarMudanca = () => {
        if (this.props.onChange) {
            const { senhaTexto, senhaPadrao, ...checklist } = this.state;
            this.props.onChange({
                checklist, // Agrupa os booleanos das partes do celular
                senhaTexto,
                senhaPadrao
            });
        }
    };

    initCanvas = () => {
        const canvas = this.canvasRef.current;
        if (!canvas) return;

        canvas.width = 200;
        canvas.height = 200;

        const size = 200;
        const padding = 30;
        const spacing = (size - padding * 2) / 2;

        this.points = [];
        for (let row = 0; row < 3; row++) {
            for (let col = 0; col < 3; col++) {
                this.points.push({
                    id: row * 3 + col + 1,
                    x: padding + col * spacing,
                    y: padding + row * spacing
                });
            }
        }

        this.drawCanvas();
    };

    drawCanvas = () => {
        const canvas = this.canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        if (this.state.senhaPadrao.length > 0) {
            ctx.beginPath();
            ctx.strokeStyle = '#e91e63';
            ctx.lineWidth = 4;
            ctx.lineJoin = 'round';
            ctx.lineCap = 'round';

            this.state.senhaPadrao.forEach((pointId, index) => {
                const pt = this.points.find(p => p.id === pointId);
                if (pt) {
                    if (index === 0) {
                        ctx.moveTo(pt.x, pt.y);
                    } else {
                        ctx.lineTo(pt.x, pt.y);
                    }
                }
            });
            ctx.stroke();
        }

        this.points.forEach(pt => {
            ctx.beginPath();
            ctx.arc(pt.x, pt.y, 8, 0, Math.PI * 2);
            ctx.fillStyle = '#000000';
            ctx.fill();
        });
    };

    handleCanvasMouseDown = (e) => {
        this.isDrawing = true;
        this.setState({ senhaPadrao: [] }, () => {
            this.handleCanvasMouseMove(e);
            this.notificarMudanca(); // Atualiza após limpar e iniciar o desenho
        });
    };

    handleCanvasMouseMove = (e) => {
        if (!this.isDrawing) return;
        const canvas = this.canvasRef.current;
        const rect = canvas.getBoundingClientRect();

        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        this.points.forEach(pt => {
            const dist = Math.hypot(pt.x - x, pt.y - y);
            if (dist < 15) {
                const len = this.state.senhaPadrao.length;

                if (len === 0 || this.state.senhaPadrao[len - 1] !== pt.id) {
                    this.setState(
                        prevState => ({ senhaPadrao: [...prevState.senhaPadrao, pt.id] }),
                        () => {
                            this.drawCanvas();
                            this.notificarMudanca(); // Atualiza a cada ponto conectado
                        }
                    );
                }
            }
        });
    };

    handleCanvasMouseUp = () => {
        this.isDrawing = false;
    };

    limparPadrao = () => {
        this.setState({ senhaPadrao: [] }, () => {
            this.drawCanvas();
            this.notificarMudanca(); // Atualiza após limpar
        });
    };

    handleCheckboxChange = (event) => {
        this.setState(
            { [event.target.name]: event.target.checked },
            this.notificarMudanca // Atualiza após mudar o checkbox
        );
    };

    handleInputChange = (event) => {
        this.setState(
            { [event.target.name]: event.target.value },
            this.notificarMudanca // Atualiza após digitar o PIN
        );
    };

    render() {
        const phoneStyle = {
            border: '2px solid #aaa',
            borderRadius: '24px',
            position: 'relative',
            backgroundColor: '#f5f5f5',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '15px 10px',
            boxSizing: 'border-box',
        };

        const sideStyle = {
            border: '2px solid #aaa',
            borderRadius: '6px',
            backgroundColor: '#f5f5f5',
        };

        return (
            <Paper elevation={0} sx={{ mt: 2, mb: 2, fontFamily: 'sans-serif' }}>
                <Grid container spacing={4} justifyContent="center" alignItems="center">

                    {/* FRENTE DO CELULAR */}
                    <Grid item xs={12} sm={4} md={2.5} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Box sx={{ ...phoneStyle, width: 140, height: 260 }}>
                            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mt: 0.5 }}>
                                <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: '#333' }} />
                                <Box sx={{ width: 30, height: 4, borderRadius: 2, backgroundColor: '#333' }} />
                            </Box>
                            <Box sx={{ width: '100%', height: 180, border: '1px solid #ddd', backgroundColor: '#fff', my: 1 }} />
                            <Box sx={{ width: 24, height: 24, borderRadius: '50%', border: '1px solid #88', mb: 0.5 }} />
                        </Box>
                        <FormControlLabel
                            control={<Checkbox checked={this.state.frenteOk} onChange={this.handleCheckboxChange} name="frenteOk" color="success" />}
                            label={"Frente"}
                            sx={{ mt: 1 }}
                        />
                    </Grid>

                    {/* VERSO DO CELULAR */}
                    <Grid item xs={12} sm={4} md={2.5} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Box sx={{ ...phoneStyle, width: 140, height: 260 }}>
                            <Box sx={{ width: 35, height: 16, border: '1px solid #777', borderRadius: 4, position: 'absolute', top: 10, left: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-around', p: '2px', backgroundColor: '#e0e0e0' }}>
                                <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#000' }} />
                                <Box sx={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#000' }} />
                            </Box>
                            <Box sx={{ width: 22, height: 26, borderRadius: '40% 40% 40% 40%', backgroundColor: '#ccc', position: 'absolute', top: '35%' }} />
                            <Box sx={{ width: 30, height: 8, border: '1px solid #ccc', position: 'absolute', bottom: 15, fontSize: 6, textAlign: 'center' }}>ooo</Box>
                        </Box>
                        <FormControlLabel
                            control={<Checkbox checked={this.state.versoOk} onChange={this.handleCheckboxChange} name="versoOk" color="success" />}
                            label={"Verso"}
                            sx={{ mt: 1 }}
                        />
                    </Grid>

                    {/* LADOS DO CELULAR (Topo, Laterais, Base) */}
                    <Grid item xs={12} sm={4} md={2} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                        {/* Topo */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Box sx={{ ...sideStyle, width: 80, height: 10 }} />
                            <FormControlLabel
                                control={<Checkbox checked={this.state.topoOk} onChange={this.handleCheckboxChange} name="topoOk" color="success" size="small" />}
                                label="Topo"
                            />
                        </Box>

                        {/* Laterais */}
                        <Box sx={{ display: 'flex', gap: 3 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Box sx={{ ...sideStyle, width: 10, height: 120 }} />
                                <FormControlLabel
                                    control={<Checkbox checked={this.state.lateralEsquerdaOk} onChange={this.handleCheckboxChange} name="lateralEsquerdaOk" color="success" size="small" />}
                                    label="Esq."
                                />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Box sx={{ ...sideStyle, width: 10, height: 120 }} />
                                <FormControlLabel
                                    control={<Checkbox checked={this.state.lateralDireitaOk} onChange={this.handleCheckboxChange} name="lateralDireitaOk" color="success" size="small" />}
                                    label="Dir."
                                />
                            </Box>
                        </Box>

                        {/* Base */}
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <Box sx={{ ...sideStyle, width: 80, height: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Box sx={{ width: 15, height: 3, backgroundColor: '#333', borderRadius: 1 }} />
                            </Box>
                            <FormControlLabel
                                control={<Checkbox checked={this.state.baseOk} onChange={this.handleCheckboxChange} name="baseOk" color="success" size="small" />}
                                label="Base"
                            />
                        </Box>
                    </Grid>

                    {/* SEÇÃO DA SENHA DO APARELHO */}
                    <Grid item xs={12} md={5}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 2, border: '1px solid #ccc', borderRadius: 2, backgroundColor: '#fafafa' }}>
                            <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Senha do Aparelho
                            </Typography>

                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                {/* Canvas do Desenho de Padrão */}
                                <Box sx={{ border: '2px solid #555', borderRadius: 1, backgroundColor: '#fff', cursor: 'pointer' }}>
                                    <canvas
                                        ref={this.canvasRef}
                                        onMouseDown={this.handleCanvasMouseDown}
                                        onMouseMove={this.handleCanvasMouseMove}
                                        onMouseUp={this.handleCanvasMouseUp}
                                        onMouseLeave={this.handleCanvasMouseUp}
                                    />
                                </Box>

                                {/* Inputs de Senha Numérica / Alfanumérica */}
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '180px' }}>
                                    <TextField
                                        label="Senha Digita/PIN"
                                        variant="outlined"
                                        size="small"
                                        name="senhaTexto"
                                        value={this.state.senhaTexto}
                                        onChange={this.handleInputChange}
                                        placeholder="Ex: 1234"
                                    />
                                    <Button variant="outlined" color="secondary" size="small" onClick={this.limparPadrao}>
                                        Limpar Padrão
                                    </Button>
                                </Box>
                            </Box>

                            {/* Debug do Padrão Selecionado */}
                            <Typography variant="caption" sx={{ mt: 2, color: '#666' }}>
                                Sequência do padrão: {this.state.senhaPadrao.length > 0 ? this.state.senhaPadrao.join(' → ') : 'Nenhum'}
                            </Typography>
                        </Box>
                    </Grid>

                </Grid>
            </Paper>
        );
    }
}

export default InspectorCelular;